'use client'

import formbricks from '@formbricks/js'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

let globalFormbricksInitialized = false
let globalInitPromise: Promise<void> | null = null

export default function Formbricks() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const isMountedRef = useRef(true)

  // Função global para inicializar Formbricks uma única vez
  const initializeFormbricks = async (): Promise<void> => {
    if (globalFormbricksInitialized) return

    if (globalInitPromise) {
      await globalInitPromise
      return
    }

    globalInitPromise = (async () => {
      try {
        await formbricks.setup({
          environmentId: 'cmfzil90b0009ou01ykwqwbyb',
          appUrl: 'https://formbricks.faculdademetropolitana.edu.br',
        })
        globalFormbricksInitialized = true
        console.log('Formbricks inicializado com sucesso')
      } catch (error) {
        console.error('Erro ao inicializar Formbricks:', error)
        globalInitPromise = null
        throw error
      }
    })()

    await globalInitPromise
  }

  // Inicializa o Formbricks quando o componente é montado
  useEffect(() => {
    isMountedRef.current = true
    initializeFormbricks()

    return () => {
      isMountedRef.current = false
    }
  }, [])

  // Registra mudanças de rota após a inicialização
  useEffect(() => {
    const handleRouteChange = async () => {
      if (!isMountedRef.current) return

      try {
        await initializeFormbricks()

        // Pequeno delay para garantir que a inicialização foi completamente processada
        const timeoutId = setTimeout(() => {
          if (
            isMountedRef.current &&
            globalFormbricksInitialized &&
            formbricks
          ) {
            formbricks.registerRouteChange()
          }
        }, 150)

        return () => clearTimeout(timeoutId)
      } catch (error) {
        console.error('Erro ao registrar mudança de rota:', error)
      }
    }

    const cleanup = handleRouteChange()
    return () => {
      if (cleanup && typeof cleanup.then === 'function') {
        cleanup.then((cleanupFn) => cleanupFn?.())
      }
    }
  }, [pathname, searchParams])

  return null
}
